import React from 'react';
import './index.css';
import { Button } from '@material-ui/core';
import { OriginatorJSON } from '../../@types/responseJson/OriginatorJSON';
import { LoanOffersJSON } from '../../@types/responseJson/loans/LoanOffersJSON';

type MyProps = {
    key: string,
    loanAmount: number,
    offerJson: LoanOffersJSON
}

type MyState = {
    loanAmount: number,
    maxApr: number | null,
    monthlyPayment: number | null,
    originator: OriginatorJSON,
    termLength: number | null,
    url: string
}

class Offer extends React.Component<MyProps, MyState>{
    constructor(props: MyProps){
        super(props);
        this.state = {
            loanAmount: this.props.loanAmount,
            maxApr: this.props.offerJson.maxApr,
            monthlyPayment: this.props.offerJson.monthlyPayment,
            originator: this.props.offerJson.originator,
            termLength: this.props.offerJson.termLength,
            url: this.props.offerJson.url
        };
    }

    public render(){
        return(
            <div className="offer">
                <div className="offerCol">
                    <img height={"auto"} width={"120px"} alt="LenderImage" src={this.state.originator.images[0].url}/>
                    <p>{this.state.originator.name}</p>
                </div>
                <div className="offerCol">
                    <p className="offerHeader">{this.state.termLength} months</p>
                    <p className="offerHeaderDesc">Term of Loan</p>
                </div>
                <div className="offerCol">
                    <p className="offerHeader">{this.state.maxApr}%</p>
                    <p className="offerHeaderDesc">Fixed APR</p>
                </div>
                <div className="offerCol">
                    <p className="offerHeader">${this.state.monthlyPayment}</p>
                    <p className="offerHeaderDesc">Est. Monthly Payment</p>
                </div>
                <div className="offerCol">
                    <p className="offerHeader">Amount: ${this.state.loanAmount}</p>                
                    <div>
                        <Button href={this.state.url} variant="contained" color="primary">Apply</Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default Offer;